/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_UnknownInputs */

const vi_einvoice_tax_unknown = /** @type {(inputs: Einvoice_Tax_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa xác định kết quả từ cơ quan thuế`)
};

/**

* @param {Einvoice_Tax_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_unknown = /** @type {((inputs?: Einvoice_Tax_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_unknown(inputs)
});